import { z } from "zod";

export const EventJoinInfoSchema = z.object({
  phrase: z.string().nullable(),
  markerEncodedPhrase: z.string().nullable(),
  // Null when the room is below the display floor, so the page can fall back
  // to its countless lede instead of quoting a number that reads as a warning.
  participantCount: z.number().int().nullable(),
});
export type EventJoinInfo = z.infer<typeof EventJoinInfoSchema>;
